(async () => {

    // Bail if this JS is loaded outside of WordPress
    if (CC_CONSTANTS.isNonWp) {
        console.cclog('Skipping alertsapi2-client...');
        return;
    }

    // ACF FIELDS
    let alertsApiUrl, staffPortalPages, studentPortalPages, announcementChannels, cacheLifetime, hideAnnouncements;

    // MISC
    let type, expireMinutes, cacheExpire;
    const cacheId = 'cc-alerts-api';

    async function fetchACFData() {
        console.cclog('2️⃣ Running: fetchACFData()');
    
        const cacheKey = 'cc-alerts-api-acf-data';
        const cacheTimeKey = 'cc-alerts-api-acf-timestamp';
        const fiveMinutes = 5 * 60 * 1000; // 5 minutes
        const now = Date.now();
    
        try {
            // Check if cached data exists and is still fresh
            const cachedData = localStorage.getItem(cacheKey);
            const cachedTimestamp = parseInt(localStorage.getItem(cacheTimeKey));
    
            let data;
            let source = 'Cache';

            if (cachedData && cachedTimestamp && (now - cachedTimestamp < fiveMinutes)) {
                console.cclog('🟩 Loading ACF option settings from cache...');
                data = JSON.parse(cachedData);
            } else {
                console.cclog('🟨 ACF option settings cache expired or empty. Fetching from API...');
                source = 'Network';
                const response = await fetch('/wp-json/options/alerts');
                data = await response.json();

                localStorage.setItem(cacheKey, JSON.stringify(data));
                localStorage.setItem(cacheTimeKey, now.toString());
            }
    
            alertsApiUrl = data.alert_api_url || "https://my.champlain.edu/announcements/api?v=2";
            staffPortalPages = data.staff_portal_pages || [];
            studentPortalPages = data.student_portal_pages || [];
            announcementChannels = data.announcement_channel || ['WWW', 'StudentPortal', 'StaffPortal'];
            cacheLifetime = parseInt(data.cache_lifetime, 10) || 3600; // seconds
            hideAnnouncements = data.hide_announcements || [];
    
            if (window.cc_debug_flag) {
                console.group('Special Announcement Settings');
                console.log('API URL:', alertsApiUrl);
                console.log('Staff Portal Pages:', staffPortalPages);
                console.log('Student Portal Pages:', studentPortalPages);
                console.log('Announcement Channels:', announcementChannels);
                console.log('Cache Lifetime:', cacheLifetime);
                console.log('Hidden Announcements:', hideAnnouncements);
                console.log('Source:', source);
                console.groupEnd();
            }

            type = announcementChannels;
            expireMinutes = cacheLifetime / 60;
            cacheExpire = 1000 * 60 * expireMinutes;

            console.cclog(`ALERTSAPI initializing with type(s) ${type}`);

            return true;
        } catch (error) {
            console.cclog('🟥 Error in fetchACFData:', error);
            return false;
        }
    }

    window.ALERTSAPI = {

        type: type,
        loadedFrom: null,
        lastUpdated: null,
        alerts: null,

        /**
         * Loads announcements
         * @example
         * // returns promise that resolves to an array of alerts in the following format: [{ id:##, title:"...", summary:"...", style:"info", type:["...", ...], date_added:"YYYY-MM-DD HH:MM:SS", date_edited:"YYYY-MM-DD HH:MM:SS", author:"...", last_edited_by:"...", display_until:"YYYY-MM-DD HH:MM:SS" }]
         * ALERTSAPI.getAlerts();
         * @returns array Returns array of alerts
         */

        async getAlerts() {

            console.cclog('1️⃣ Running: getAlerts()');

            await fetchACFData();

            ALERTSAPI.hideAnnouncements = hideAnnouncements;
            ALERTSAPI.announcementChannels = announcementChannels;
            ALERTSAPI.staffPortalPages = staffPortalPages;
            ALERTSAPI.studentPortalPages = studentPortalPages;

            // try last loaded
            if (ALERTSAPI.lastUpdated && ALERTSAPI.alerts) {
                const now = new Date();
                if (!!Date.parse(ALERTSAPI.lastUpdated) && now.getTime() - cacheExpire < (new Date(ALERTSAPI.lastUpdated)).getTime()) {
                    console.cclog('loading previously loaded alerts', ALERTSAPI.alerts)
                    return ALERTSAPI.alerts;
                }
            }

            // try localstorage
            if (loadAlertsFromCache()) {
                console.cclog('alerts loaded from cache.', ALERTSAPI.alerts);
                return ALERTSAPI.alerts;
            }

            // try api
            if (await loadAlertsFromApi()) {
                console.cclog('alerts loaded from api.', ALERTSAPI.alerts);
                return ALERTSAPI.alerts;
            }

            // fail
            console.cclog(`🟥 ERROR: failed to load alerts of type ${type}.`);
            return [];
        },

        setAlerts(alerts) {
            console.cclog('Running: setAlerts()');
            if (!Array.isArray(alerts)) {
                console.cclog("🟥ERROR: setAlerts: No data specified.");
                return null;
            }

            ALERTSAPI.alerts = alerts;
            ALERTSAPI.lastUpdated = new Date();

            localStorage.setItem(cacheId, JSON.stringify({
                data: alerts,
                date: new Date()
            }));
        }

    };

    function loadAlertsFromCache() {
        console.cclog('Running: loadAlertsFromCache()');
    
        const rawCacheData = localStorage.getItem(cacheId);
        if (!rawCacheData) return false;
        const parsedCacheData = JSON.parse(rawCacheData);
        if (!parsedCacheData) return false;
        const now = new Date();
        console.cclog('now:', now);
        // cacheExpire = 60000 // this is for testing
        console.cclog('cacheExpire:', cacheExpire); // this comes from the fetchACFData() function and isnt availabe here
        console.cclog('parsedCacheData.date:', parsedCacheData.date);
        if (!!Date.parse(parsedCacheData?.date) && now.getTime() - cacheExpire < (new Date(parsedCacheData.date)).getTime()) {
            ALERTSAPI.alerts = parsedCacheData.data.filter(a => type.some(t => a.type.includes(t)));
            ALERTSAPI.lastUpdated = parsedCacheData.date;
            ALERTSAPI.loadedFrom = 'cache';
            return true;
        }
        console.cclog('alerts in cache are expired.', parsedCacheData);
        return false;
    }
    
    async function loadAlertsFromApi() {
        console.cclog('Running: loadAlertsFromApi()');
    
        let response;
        try {
            console.cclog('fetching:', alertsApiUrl);
            response = await fetch(alertsApiUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            } else {
                console.cclog('response is ok:', response.status);
            }
            response = await response.json();
        } catch (error) {
            console.cclog("ERROR: Announcements API network-level issue.", error.message);
            return false;
        }
        if (response?.status !== "success" || !response?.data || !Array.isArray(response.data)) {
            console.cclog("ERROR: Announcements API returned invalid result.", response);
            return false;
        } else {
            console.cclog('response sucess:', response.status);
        }

        console.cclog('response.data:', response.data);

        console.cclog('type(s):', type);

        ALERTSAPI.setAlerts(response.data.filter(a => type.some(t => a.type.includes(t))));
        ALERTSAPI.loadedFrom = 'api';

        if (window.cc_debug_flag && ALERTSAPI.alerts.length === 0 && response.data.length > 0) {
            console.log(`of ${response.data.length} alerts, none are of types "${type.join(', ')}"`);
        }
    
        // ALERTSAPI.setAlerts(ALERTSAPI.alerts);
        console.cclog('ALERTSAPI.alerts:', ALERTSAPI.alerts);
        return true;
    }

})();